import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin, adminMe, setToken, clearToken, getToken } from "../lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = logged out, object = logged in
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!getToken()) {
      setAdmin(false);
      setChecking(false);
      return;
    }
    adminMe()
      .then((data) => setAdmin(data))
      .catch(() => {
        clearToken();
        setAdmin(false);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await adminLogin(email, password);
    setToken(data.token);
    setAdmin(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setAdmin(false);
  }, []);

  const refresh = useCallback(async () => {
    const data = await adminMe();
    setAdmin(data);
    return data;
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, checking, login, logout, refresh, setAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
